import React from 'react';

const Card = ({ title, value, icon, footer, valueClass = '' }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider">{title}</h3>
          <p className={`mt-2 text-3xl font-bold text-gray-900 ${valueClass}`}>{value}</p>
        </div>
        <div className="bg-indigo-500 text-white p-3 rounded-full">
          {icon}
        </div>
      </div>
      {footer && <p className="text-sm text-gray-500 mt-4">{footer}</p>}
    </div>
  );
};

export default Card;